import { createContext, useContext } from "react"
import { User as FirebaseUser } from "firebase/auth"
import { FirestoreError } from "firebase/firestore"

// TODO: Support multi organisation users (apart from super-user)
export type User = FirebaseUser & {
    organisation: string;
    groups: string[] | true;
    roles: string[] | true;
    isSuper: boolean;
}

export type AuthContextProps = {
    isAuth: boolean | null
    user: User | null
    setOrganisation: (organisation: string) => void
    hasRole: (role: string) => boolean
    loading: boolean
    error?: FirestoreError
}

export const AuthenticationContext = createContext<AuthContextProps>({
    isAuth: null,
    user: null,
    setOrganisation: () => null,
    hasRole: () => false,
    loading: false,
    error: undefined,
})

export const useAuth = () => useContext(AuthenticationContext)

export * from "./AuthenticationProvider"
